const IsChecked = {
  data() {
    return {
      checked: false,
    }
  },
  methods: {
    onChange(e) {
      this.$emit('input', e)
    },
  },
  computed: {
    isChecked() {
      return this.selected.indexOf(this.item.id) > -1
    },
  },
}

export default IsChecked
